import React from 'react';

import { Tooltip as RadixTooltip, TooltipProps } from '@radix-ui/themes';
import classNames from 'classnames';

import styles from './Tooltip.module.less';

function Tooltip({
  inset = false,
  selectable = false,
  // Background has to be handled like this to reflect change on the triangle icon
  backgroundColor = 'var(--gray-12)',

  ref,
  ...props
}: TooltipProps & {
  inset?: boolean;
  backgroundColor?: string;
  selectable?: boolean;
  ref?: React.Ref<HTMLDivElement>;
}) {
  return (
    <RadixTooltip
      ref={ref}
      {...props}
      className={classNames(
        props.className,
        styles.tooltip,
        inset ? 'p-0' : 'px-fly-4 py-fly-3',
        selectable ? styles.selectable : '',
        'box-border rounded-fly-3'
      )}
      style={
        {
          '--tooltip-background-color': backgroundColor,
          backgroundColor: backgroundColor,
        } as any
      }
      content={
        <span className='font-regular text-slate-1 w-full text-center text-size-fly-1'>
          {props.content}
        </span>
      }
    />
  );
}

export { Tooltip, type TooltipProps };
